module.exports = __webpack_public_path__ + "fonts/Source_Sans_3-normal-700-latin.3016460.woff2";